var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69601 11.5093L9.59439 3.61095L9.59439 10.5123C9.59439 11.0639 10.0469 11.5164 10.5985 11.5164C11.15 11.5164 11.5955 11.0709 11.5955 10.5194L11.5955 1.19972C11.5955 0.648172 11.15 0.202695 10.5985 0.202696L1.27881 0.188554C0.727271 0.188554 0.281794 0.634031 0.281794 1.18557C0.281794 1.73712 0.727272 2.18259 1.27882 2.18259L8.18018 2.19674L0.281794 10.0951C-0.107115 10.484 -0.107115 11.1204 0.281794 11.5093C0.670703 11.8982 1.3071 11.8982 1.69601 11.5093Z",
    fill: "#1A2461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightUpArrow);
export default __webpack_public_path__ + "static/media/rightUpArrow.bd5bd457b1f98324064c65eb1438af96.svg";
export { ForwardRef as ReactComponent };